import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { VFC } from 'react';

import { addresses } from '@/constants/addresses';
import OpenSeaLogo from '@/icons/opensea-logo-white-circle.svg';

import styles from './ViewOnOpenSeaButton.module.scss';

type Props = {
  tokenID: number;
  tokenVersion: 1 | 2;
};

const ViewOnOpenSeaButton: VFC<Props> = ({ tokenID, tokenVersion }: Props) => {
  const { t, i18n } = useTranslation();

  const isTestnet = process.env.NEXT_PUBLIC_ETH_NETWORK !== 'Mainnet';

  const networkPrefix = isTestnet ? 'goerli' : 'ethereum';

  const erc1155ContractAddress =
    tokenVersion === 2 ? addresses.AniftyERC1155V2 : addresses.AniftyERC1155V1;

  const openSeaLinkURL = `https://${
    isTestnet ? `testnets.` : ''
  }opensea.io/assets/${networkPrefix}/${erc1155ContractAddress}/${tokenID}`;

  return (
    <a
      href={openSeaLinkURL}
      className={classNames(styles.viewOnOpenSeaButton, {
        [styles.upperCaseText]: i18n.language !== 'ja',
      })}
      target="_blank"
      rel="noopener noreferrer"
    >
      <OpenSeaLogo />
      {t('creationPage.viewOnOpenSea')}
    </a>
  );
};

export default ViewOnOpenSeaButton;
